import { createFileRoute } from "@tanstack/react-router";
import { PostOpInstructions } from "@/components/site/PostOpInstructions";

// Lovable-hosted asset URLs are not served by the GitHub -> Cloudflare
// deployment, so stream the video directly from CloudFront (case-sensitive).
const POST_OP_VIDEO =
  "https://d17ehmrb6zqtjv.cloudfront.net/Videos/Videos%20with%20Captions/RESTOREDenverPost-OpInstructionsV4(1).mp4#t=0.1";

export const Route = createFileRoute("/denver-post-op")({
  head: () => ({
    meta: [
      { title: "SMS – Day Of Procedure (Denver) - Restore Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair Denver post-operative instructions: pain management, ATP spray, icing, swelling, washing, exercise and regrowth timeline after your FUE hair transplant.",
      },
      {
        property: "og:title",
        content: "Post-Operative Instructions — Denver | RESTORE® Hair",
      },
      {
        property: "og:description",
        content:
          "Day-by-day aftercare instructions for RESTORE® Hair Denver patients following an FUE hair transplant procedure.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/denver-post-op/" }],
  }),
  component: () => <PostOpInstructions video={POST_OP_VIDEO} />,
});
